<script lang="ts">
    import {createEventDispatcher, onDestroy, onMount, tick} from "svelte";
    import DialogView from "./DialogView.svelte";
    import {ValueUtil} from "../../../lib/Common/Value/ValueUtil";
    import {MessageStore} from "../../../store/MessageStore";
    import {FormUtil} from "../../../lib/Common/Form/FormUtil";

    const dispatcher = createEventDispatcher();

    export let editData = null;
    let oldEditData = null;

    export let title: string = '';
    export let canSave = true;
    export let canDelete = false;

    export let zIndex: number = 0;


    $: isShow = (() => {
        if (editData == null) {
            return false;
        }

        return true;
    })();
    $: isShowDelete = (() => {
        if (!isShow) {
            return false;
        }
        if (!canDelete) {
            return false;
        }

        if (!('id' in editData)) {
            return false;
        }
        const id = editData.id;
        if (ValueUtil.isEmpty(id)) {
            return false;
        }
        return true;
    })();

    let editContentElement = null;

    let isChange = false;

    onMount(() => {
    });

    onDestroy(() => {
    });


    $: {
        // console.log({editData, oldEditData});

        if (editData != null && oldEditData != null) {
            // 編集時にイベントを設定
            addBeforeUnloadEvent();
        }
        if (editData != oldEditData) {
            oldEditData = editData;
        }
    }

    $: {
        if (editData == null) {
            // editData がなくなった時、beforeunload イベントを削除
            removeBeforeUnloadEvent();

        }
    }

    function onClickSave() {
        if (!canSave) {
            return false;
        }

        // 必須項目をチェック
        if (editContentElement != null) {
            const isSafeRequire = FormUtil.isSafeRequire(editContentElement, true);
            if (!isSafeRequire) {
                // 必須項目の未入力があった
                return;
            }
        }


        MessageStore.showConfirmInformationYesNo("更新してもよろしいですか？", () => {
            dispatcher('save', {editData: editData});
        });

    }

    function cancel() {
        const close = () => {
            dispatcher('cancel', {});

            // ダイアログを閉じる際にイベントを削除
            removeBeforeUnloadEvent();
        }

        if (isChange) {
            MessageStore.showConfirmInformationYesNo("編集してますが、キャンセルしてよろしいですか？", () => {
                close();
            });

        } else {
            close();
        }


    }

    function beforeUnload(event) {
        event.returnValue = "編集ですが、ページを離れようとしています。よろしいですか？";
    }

    /**
     * BeforeUnload のイベントを設定
     */
    async function addBeforeUnloadEvent() {
        await tick();
        if (isChange) {
            return;
        }
        // console.log('window.addEventListener');
        window.addEventListener('beforeunload', beforeUnload)
        isChange = true;
    }

    /**
     * BeforeUnload のイベントを削除
     */
    async function removeBeforeUnloadEvent() {
        await tick();
        if (!isChange) {
            return;
        }
        console.log('window.removeEventListener');
        window.removeEventListener('beforeunload', beforeUnload)
        isChange = false;

    }

    function onClickDelete() {
        MessageStore.showConfirmDangerYesNo("削除してもよろしいですか？", () => {
            dispatcher('delete', {editData: editData});
        });
    }


</script>

<DialogView
        isShow={isShow}
        title={title}
        on:close={cancel}
        on:show
        zIndex={zIndex}

>
    <div class="edit-area">
        <div class="edit-content" bind:this={editContentElement}>
            {#if editData != null}
                <slot/>
            {/if}
            <div class="button-margin-area"></div>
        </div>
        <div class="button-gradation-area"></div>
        <div class="button-area">
            <button class="save primary" on:click={onClickSave} disabled={!canSave}>
                保存
            </button>
            {#if isShowDelete}
                <button class="delete danger" on:click={onClickDelete}>
                    削除
                </button>
            {:else}
                <button class="sub small" on:click={cancel}>
                    キャンセル
                </button>

            {/if}

        </div>

    </div>

</DialogView>


<style lang="scss">
    .edit-area {
        min-height: 200px;
        padding-bottom: 60px;

        .edit-content {
            //flex-grow: 1;
            //padding-bottom: 40px;

            .button-margin-area {
                height: 40px;
            }
        }

        .button-gradation-area {
            background: linear-gradient(0deg, var(--background-color), transparent);
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 40px;

            pointer-events: none;
        }

        .button-area {
            //margin-top: 32px;
            display: flex;
            gap: 12px;
            justify-content: flex-end;

            position: absolute;
            right: 0;
            bottom: 0;
            padding-right: 10px;
            padding-bottom: 10px;
        }
    }
</style>